"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var ThreadListLabel = function ThreadListLabel(_ref) {
  var children = _ref.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["children"]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: "flex items-center pl-12 text-sm text-light uppercase"
  }, rest), children);
};

var _default = ThreadListLabel;
exports["default"] = _default;
//# sourceMappingURL=Label.js.map